import React, { useState } from 'react';
import {
  AquistaButton,
  AquistaButtonsContainer,
  CompanyInfoElements,
  CompanyInformationContainer,
  LeftCol,
  LogoContainer,
  LogoPriceContainer,
  Price,
  PriceContainer,
  QuotationCardStyles,
  QuoteInformationContainer,
  QuoteInformationItem,
  RightCol,
  SavedButton,
} from '../ResultPageComponents/v2/QuotationCard.styles';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';
import preventiveIcon from '../../../../assets/redesign_icons/preventivo-icon.svg';
import preContractIcon from '../../../../assets/redesign_icons/pre-contract-icon.svg';
import ProfessionInfoModal from '../Modal/ProfessionInfoModal';
import GuaranteesModalProfession from '../Modal/GuaranteesModalProfession';
import { BACKEND_BASE_URL } from '../../../../config';
import ProfessionWeBindModal from '../Modal/ProfessionWeBindModal';
import { downloadFile } from '../../../../services/axios-client/axeHelpers';
import { backOfficeAxe } from '../../../../services/axios-client/backofficeClient';
import { downloadResourceDocsBackoffice } from '../../../../services/axios-client/axeCommonsBackOffice';

function ProfessionCard({
  requestInfo,
  userData,
  setOpenModal,
  set_informativi,
  docs,
  revealModal,
  extensions,
  requestToken,
  selectableExtensions,
  profession,
  selectQuotation,
  //  quoteId,
}) {
  const [showModal, setShowModal] = useState(false);
  // const navigate = useNavigate();
  const openModal = () => {
    setShowModal(!showModal);
  };

  // ? Fix to work for backoffice
  const downloadModuloDiProposta = async () => {
    const res = await backOfficeAxe.get(
      `/quotations/${userData.id}/modulo-di-proposta/generate`,
      {
        responseType: 'blob',
      },
    );

    downloadFile(res.data);
  };

  // const goToNextPage = () => {
  //   navigate(`/quotes/profession/purchase/${quoteId}`);
  // };

  return (
    <>
      {(showModal && userData.company_id === 4) && (
        <ProfessionInfoModal
          userData={userData}
          setShowModal={setShowModal}
          docs={docs}
          set_informativi={set_informativi}
          extensions={extensions}
          requestToken={requestToken}
          selectableExtensions={selectableExtensions}
          profession={profession}
        />
      )}

      {showModal && userData.company_id === 1002 && (
        <ProfessionWeBindModal
          userData={userData}
          setShowModal={setShowModal}
          docs={docs}
          set_informativi={set_informativi}
          extensions={extensions}
          requestToken={requestToken}
          selectableExtensions={selectableExtensions}
          profession={profession}
        />
      )}

      {revealModal && (
        <GuaranteesModalProfession
          setOpenModal={setOpenModal}
          profession={profession}
          extensions={extensions}
          requestToken={requestToken}
          selectableExtensions={selectableExtensions}
        />
      )}
      <QuotationCardStyles
        className={userData.is_aquista === 1 ? 'selected' : ''}
      >
        <LeftCol>
          <div>
            <LogoPriceContainer>
              <LogoContainer>
                <img
                  src={BACKEND_BASE_URL + userData.company.logo}
                  alt={`${userData.company.name} Logo`}
                />
              </LogoContainer>
              <PriceContainer>
                <Price>
                  <h5>Prezzo annuo:</h5>
                  <h2>
                    &euro;
                    {userData.amount.toFixed(2).toLocaleString()}
                  </h2>
                </Price>
              </PriceContainer>
            </LogoPriceContainer>
          </div>
        </LeftCol>
        <RightCol>
          <div>
            {userData.company_id === 4 && (
              <>
                <CompanyInformationContainer>
                  <CompanyInfoElements onClick={() => openModal()}>
                    <img src={infoIcon} alt="" />
                    <p>Maggiori informazioni</p>
                  </CompanyInfoElements>
                  {docs[profession.profession] !== '' && (
                    <CompanyInfoElements
                      onClick={() => downloadResourceDocsBackoffice(4, profession.profession)}
                      title={`${docs[profession.profession]}`}
                    >
                      <img src={preventiveIcon} alt="" />
                      <p>Questionario</p>
                    </CompanyInfoElements>
                  )}
                  {set_informativi[profession.profession] !== '' && (
                    <CompanyInfoElements
                      onClick={() => downloadResourceDocsBackoffice(8, profession.profession)}
                      title={`${set_informativi[profession.profession]}`}
                    >
                      <img src={preContractIcon} alt="" />
                      <p>Informativa Precontrattuale</p>
                    </CompanyInfoElements>
                  )}
                </CompanyInformationContainer>
              </>
            )}

            {userData.company_id === 1002 && (
              <>
                <CompanyInformationContainer>
                  <CompanyInfoElements onClick={() => openModal()}>
                    <img src={infoIcon} alt="" />
                    <p>Maggiori informazioni</p>
                  </CompanyInfoElements>
                  {docs[profession.profession] !== '' && (
                    <CompanyInfoElements
                      onClick={() => downloadModuloDiProposta()}
                      title={`${docs[profession.profession]}`}
                    >
                      <img src={preventiveIcon} alt="" />
                      <p>Questionario</p>
                    </CompanyInfoElements>
                  )}
                  {set_informativi[profession.profession] !== '' && (
                    <CompanyInfoElements
                      onClick={() => downloadResourceDocsBackoffice(41, profession.profession)}
                      title={`${set_informativi[profession.profession]}`}
                    >
                      <img src={preContractIcon} alt="" />
                      <p>Informativa Precontrattuale</p>
                    </CompanyInfoElements>
                  )}
                </CompanyInformationContainer>
              </>
            )}

            {userData.company_id === 4 && (
              <>
                <QuoteInformationContainer>
                  <QuoteInformationItem>
                    <h6>Compagnia:</h6>
                    <p>{userData.company.name}</p>
                  </QuoteInformationItem>
                  <QuoteInformationItem>
                    <h6>Prodotto:</h6>
                    <p>RC Professionale</p>
                  </QuoteInformationItem>
                  <QuoteInformationItem>
                    <h6>Professione:</h6>
                    <p>{profession.profession_desc}</p>
                  </QuoteInformationItem>
                  {profession.billed_maximum != 0 && (
                    <QuoteInformationItem>
                      <h6>Massimale:</h6>
                      <p>
                        {Number(profession.billed_maximum).toLocaleString('it-IT', {
                          minimumFractionDigits: 2,
                        })}
                        &euro;
                      </p>
                    </QuoteInformationItem>
                  )}
                </QuoteInformationContainer>
                <QuoteInformationContainer className="ms-3 ms-sm-0">
                  <QuoteInformationItem>
                    <h6>Franchigia:</h6>
                    <p>1.000,00&euro;</p>
                  </QuoteInformationItem>
                  <QuoteInformationItem>
                    <h6>Retroattività:</h6>
                    <p>{profession.retroactivity_name}</p>
                  </QuoteInformationItem>
                  <QuoteInformationItem>
                    <h6>Scaglione fatturato:</h6>
                    <p>
                      {Number(profession.billed).toLocaleString('it-IT', {
                        minimumFractionDigits: 2,
                      })}
                      &euro;
                    </p>
                  </QuoteInformationItem>
                  <QuoteInformationItem>
                    <h6>Tempo medio di emissione:</h6>
                    <p>2 giorni</p>
                  </QuoteInformationItem>
                </QuoteInformationContainer>
              </>
            )}
            {userData.company_id === 1002 && (
              <>
                <QuoteInformationContainer>
                  <QuoteInformationItem>
                    <h6>Compagnia:</h6>
                    <p>{userData.company.name}</p>
                  </QuoteInformationItem>
                  <QuoteInformationItem>
                    <h6>Prodotto:</h6>
                    <p>RC Professionale</p>
                  </QuoteInformationItem>
                  <QuoteInformationItem>
                    <h6>Professione:</h6>
                    <p>{profession.profession_desc}</p>
                  </QuoteInformationItem>
                  {profession.billed_maximum != 0 && (
                    <QuoteInformationItem>
                      <h6>Massimale:</h6>
                      <p>
                        {Number(profession.billed_maximum).toLocaleString('it-IT', {
                          minimumFractionDigits: 2,
                        })}
                        &euro;
                      </p>
                    </QuoteInformationItem>
                  )}
                </QuoteInformationContainer>
                <QuoteInformationContainer className="ms-3 ms-sm-0">
                  {userData.deductible
                    && (
                      <QuoteInformationItem>
                        <h6>Franchigia:</h6>
                        {Number(userData.deductible).toLocaleString('it-IT', {
                          minimumFractionDigits: 2,
                        })}
                        &euro;
                      </QuoteInformationItem>
                    )}
                  {userData.deductible_plus
                    && (
                      <QuoteInformationItem>
                        <h6>Franchigia Incarichi:</h6>
                        {Number(userData.deductible_plus).toLocaleString('it-IT', {
                          minimumFractionDigits: 2,
                        })}
                        &euro;
                      </QuoteInformationItem>
                    )}
                  {profession.retroactivity_name
                    && (
                      <QuoteInformationItem>
                        <h6>Retroattività:</h6>
                        <p>{profession.retroactivity_name}</p>
                      </QuoteInformationItem>
                    )}
                  {profession.billed
                    && (
                      <QuoteInformationItem>
                        <h6>Scaglione fatturato:</h6>
                        <p>
                          {Number(profession.billed).toLocaleString('it-IT', {
                            minimumFractionDigits: 2,
                          })}

                          &euro;
                        </p>
                      </QuoteInformationItem>
                    )}

                </QuoteInformationContainer>
              </>
            )}
          </div>
          <AquistaButtonsContainer>
            {requestInfo.processing_quotation_id !== userData.id ? (
              <AquistaButton
                onClick={() => selectQuotation(userData.id)}
                className="result-profession-sixth-step"
              >
                Seleziona
              </AquistaButton>
            ) : (
              requestInfo.processing_quotation_id === userData.id && (
              <SavedButton>Aggiunto</SavedButton>
              )
            )}
          </AquistaButtonsContainer>
        </RightCol>
      </QuotationCardStyles>
    </>
  );
}

export default ProfessionCard;
